export default __webpack_public_path__ + "static/media/pic8.a1ed8ab4.jpg";